module.exports = __webpack_public_path__ + "close-aca529d9aa52687de299.svg";